import common from "./common"
import bioSafe from "./biosafe"
export default Object.assign({}, bioSafe, common)